module.exports = __webpack_public_path__ + "static/cimbleC-5b86daad0245030bb902fbebbffbcf7d.png";